function identifyStringFormat(str) {
  if (isJSON(str)) {
    return "JSON";
  } else if (isHTML(str)) {
    return "HTML";
  } else {
    return "Unknown format";
  }
}

function isJSON(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

function isHTML(str) {
  const trimmedStr = str.trim();
   return trimmedStr.startsWith("<") && trimmedStr.endsWith(">")
}

export{identifyStringFormat}